import React from 'react';
import './App.css';
import LoginPage from './LoginPage';
import HomePage from './HomePage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SignUpPage from './SignUpPage';
import LoginSuccess from './LoginSuccess';
import AccountPage from './AccountPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/account" element={<AccountPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<SignUpPage />} />
        <Route path="/login-success" element={<LoginSuccess />} />
        <Route path="/" element={<HomePage/>} />
        {/* Add more routes here as needed */}
      </Routes>
    </Router>
  );
}

export default App;
